var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prismic-rich-text',{staticClass:"content-section",class:'text-section-' + _vm.slice.slice_label,attrs:{"field":_vm.slice.primary.rich_text}})}
var staticRenderFns = []

export { render, staticRenderFns }